import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes';
import { RoutingConfig } from '@app/routing/routing.config';

@Component({
  selector: 'app-page-screen',
  templateUrl: 'screen.component.html',
  styleUrls: [`./screen.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ScreenComponent extends DevicesClass implements OnInit {
  public ScreenTemplateEmpty: boolean = this.onScreenTemplateEmpty();

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  onScreenTemplateEmpty(): boolean {
    return location.pathname.split('/').some((item, key) => {
      return item === RoutingConfig.SignOAuth;
    });
  }
}
